'use strict';

// Carousels here
(function ($, Drupal) {

	// Top Notification Block Carousel
	var notificationBarCarousel, notificationBarOptions;

	notificationBarCarousel = $('.c-notification-block .owl-carousel');

	notificationBarOptions = {
		loop: true,
		nav: false,
		autoHeight: false,
		dots: false,
		margin: 0,
		responsive: {
			0: {
				items: 1
			}
		}
	};

	if (notificationBarCarousel.length) {
		notificationBarCarousel.owlCarousel(notificationBarOptions);
		//$('.page-header').addClass('has-notify-banner');
	}

	var notifyBarNext = $('.notification-bar-nav .next');
	var notifyBarPrev = $('.notification-bar-nav .prev');

	notifyBarNext.on('click', function () {
		notificationBarCarousel.trigger('next.owl.carousel');
		return false;
	});

	notifyBarPrev.on('click', function () {
		notificationBarCarousel.trigger('prev.owl.carousel');
		return false;
	});

	// Cards Carousels
	var cardCarousel, cardCarouselOpts;

	cardCarouselOpts = {
		loop: true,
		nav: true,
		autoHeight: false,
		dots: true,
		margin: 20,
		responsive: {
			0: {
				items: 1
			}
		}
	};

	cardCarousel = $('.cards .row.owl-carousel:not(.multi-carousel)');

	// Gallery Carousel
	var galleryCarousel, galleryCarouselOpts;
	galleryCarousel = $('.photo-gallery .owl-carousel');
	galleryCarouselOpts = {
		loop: true,
		nav: true,
		dots: true,
		items: 1
	};
	//
	// $(window).on('load', function(){
	// 	if(cardCarousel.length) {
	// 		cardCarousel.owlCarousel(cardCarouselOpts);
	// 	}
	//
	// 	if(galleryCarousel.length) {
	// 		galleryCarousel.owlCarousel(galleryCarouselOpts);
	// 	}
	// });

	// Offers Carousel
	$('.offers .owl-carousel').owlCarousel({
		dots: false,
		dotsData: '<span>Carousel Item</span>',
		loop: false,
		rewind: true,
		nav: true,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2,
				margin: 20
			},
			1024: {
				margin: 19,
				items: 3
			},
			1440: {
				margin: 20
			}
		},
		onInitialized: function onInitialized() {
			$('.offers .owl-carousel .owl-nav button').removeAttr('role');
		}
	});

	var multiCardCarousel, multiCardCarouselOpts;

	multiCardCarousel = $('.cards .multi-carousel');

	multiCardCarouselOpts = {
		loop: true,
		nav: true,
		// autoHeight: false,
		dots: false,
		margin: 20,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			1280: {
				items: 3
			},
			1440: {
				items: 4
			}
		}
	};

	if (multiCardCarousel.length) {
		multiCardCarousel.owlCarousel(multiCardCarouselOpts);
	}

	var sync1 = $("#sync1");
	var sync2 = $("#sync2");
	var slidesPerPage = 6; //globaly define number of elements per page
	var syncedSecondary = true;

	sync1.owlCarousel({
		items: 1,
		nav: true,
		autoplay: false,
		dots: false,
		loop: true,
		responsiveRefreshRate: 200
	}).on('changed.owl.carousel', syncPosition);

	sync2.on('initialized.owl.carousel', function () {
		sync2.find(".owl-item").eq(0).addClass("current");
	}).owlCarousel({
		items: slidesPerPage,
		dots: false,
		nav: true,
		smartSpeed: 200,
		slideSpeed: 500,
		slideBy: 1, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
		responsiveRefreshRate: 100,
		responsive: {
			0: {
				items: 2
			},
			768: {
				items: 4
			},
			1280: {
				items: 6
			}
		}
	}).on('changed.owl.carousel', syncPosition2);

	function syncPosition(el) {
		//if you set loop to false, you have to restore this next line
		//var current = el.item.index;

		//if you disable loop you have to comment this block
		var count = el.item.count - 1;
		var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

		if (current < 0) {
			current = count;
		}
		if (current > count) {
			current = 0;
		}

		//end block

		sync2.find(".owl-item").removeClass("current").eq(current).addClass("current");
		var onscreen = sync2.find('.owl-item.active').length - 1;
		var start = sync2.find('.owl-item.active').first().index();
		var end = sync2.find('.owl-item.active').last().index();

		if (current > end) {
			sync2.data('owl.carousel').to(current, 100, true);
		}
		if (current < start) {
			sync2.data('owl.carousel').to(current - onscreen, 100, true);
		}
	}

	function syncPosition2(el) {
		if (syncedSecondary) {
			var number = el.item.index;
			sync1.data('owl.carousel').to(number, 100, true);
		}
	}

	sync2.on("click", ".owl-item", function (e) {
		e.preventDefault();
		var number = $(this).index();
		sync1.data('owl.carousel').to(number, 300, true);
	});
})(jQuery, Drupal);